var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"footer"}},[_c('iframe',{style:({
      width: _vm.iframeWidth,
      'max-width': '95%',
      height: _vm.iframeHeight,
      border: 'none',
      'background-color': _vm.iframeBackground,
    }),attrs:{"src":_vm.iframeUrl}})])}
var staticRenderFns = []

export { render, staticRenderFns }